<template>
    <form-row title="Mortgage Contingency Due Date*">
        <input-date
            :value="mortgage.mortgage_contingency_due_date"
            name="mortgage_contingency_due_date"
            :read_only="read_only"
            input_id="mortgage-contingency-date"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        mortgage: {},
        read_only: { default: false },
    },
}
</script>
